module.exports = __webpack_public_path__ + "static/media/proposalBlurbs.44739ff1.svg";